import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import HomePageImg from 'svg/img/kitchen-compressed.jpg';
import HomePageImgBlur from 'svg/img/kitchen-compressed-blur.jpg';
import Container from 'common/Container';
import ProgressiveImage from 'common/ProgressiveImage';
import { Headline } from './components';

const Picture = () => {
  const theme = useTheme();
  return (
    <Box
      position={'relative'}
      overflow={'hidden'}
      sx={{
        backgroundColor: theme.palette.grey[900],
      }}
    >
      <ProgressiveImage
        src={HomePageImg}
        placeholderSrc={HomePageImgBlur}
        alt={''}
        loading={'eager'}
        fetchPriority={'high'}
        position={'absolute'}
        top={0}
        right={0}
        bottom={0}
        left={0}
        imgSx={{ objectPosition: 'center' }}
      />
      <Box
        position={'absolute'}
        top={0}
        right={0}
        bottom={0}
        left={0}
        zIndex={1}
        sx={{
          background: theme.palette.common.black,
          opacity: 0.2,
        }}
      />
      <Container zIndex={2} position={'relative'}>
        <Container
          marginLeft={'0 !important'}
          maxWidth={{ md: '50% !important' }}
        >
          <Headline />
        </Container>
      </Container>
    </Box>
  );
};

export default Picture;
